import { gql } from '@apollo/client';

const Fragments = {
  partnerFileBulk: gql`
    fragment partnerFileBulk on PartnerFileBulk {
      partnerId
      partnerName
      partnerCode
      partnerTypeId
      uniqueId
      actDate
    }
  `
};

export default Fragments;
